import {
  BabyCarriageIcon,
  BarbellIcon,
  BathtubIcon,
  BriefcaseIcon,
  CallBellIcon,
  CarIcon,
  CoffeeIcon,
  DiscoBallIcon,
  ElevatorIcon,
  ForkKnifeIcon,
  KeyIcon,
  LetterCirclePIcon,
  PhoneCallIcon,
  SecurityCameraIcon,
  ShieldCheckIcon,
  SuitcaseRollingIcon,
  SwimmingPoolIcon,
  TowelIcon,
  VanIcon,
  WashingMachineIcon,
  WheelchairIcon,
  WifiHighIcon,
  WindIcon,
} from "@phosphor-icons/react";

import {
  IconPlusSquare,
  IconSupport24,
  IconValetParking,
} from "@/components/Icons";
import type {
  FacilityIconComponent,
  CommonFacilityItem,
  FacilityCategoryKey,
} from "@/features/hotels/utils/facilities/types";

const CATEGORY_ICONS: Record<FacilityCategoryKey, FacilityIconComponent> = {
  "core-essentials": WifiHighIcon,
  accessibility: VanIcon,
  safety: IconSupport24,
  leisure: SwimmingPoolIcon,
  dining: ForkKnifeIcon,
  service: CallBellIcon,
  sports: BarbellIcon,
  "core-support": WashingMachineIcon,
  wellness: BathtubIcon,
  family: BabyCarriageIcon,
  business: BriefcaseIcon,
  entertainment: DiscoBallIcon,
  secondary: PhoneCallIcon,
  policies: ShieldCheckIcon,
  admin: KeyIcon,
  extra: IconPlusSquare,
};

const COMMON_FACILITY_ICONS: Record<string, FacilityIconComponent> = {
  wifi: WifiHighIcon,
  "air-conditioning-public-areas": WindIcon,
  "24-hour-reception": IconSupport24,
  "towels-and-bed-linen": TowelIcon,
  "lift-access": ElevatorIcon,
  "car-park": LetterCirclePIcon,
  "secure-parking": SecurityCameraIcon,
  "valet-parking": IconValetParking,
  "wheelchair-accessible": WheelchairIcon,
  "room-service": CallBellIcon,
  "laundry-service": WashingMachineIcon,
  "luggage-room": SuitcaseRollingIcon,
  "airport-shuttle": VanIcon,
  "car-hire": CarIcon,
  gym: BarbellIcon,
  restaurant: ForkKnifeIcon,
  "swimming-pool": SwimmingPoolIcon,
  breakfast: CoffeeIcon,
};

export const getCategoryIcon = (
  categoryKey: FacilityCategoryKey,
): FacilityIconComponent => CATEGORY_ICONS[categoryKey];

export const getCommonFacilityIcon = (
  facilityKey: CommonFacilityItem["key"],
): FacilityIconComponent | undefined => COMMON_FACILITY_ICONS[facilityKey];
